import React from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { forwardRef } from 'react';

const BaseInput = forwardRef(({ name, ...otherProps }, ref) => {
  const [field, meta] = useField(name);
  const configInput = {
    ...field,
    ...otherProps,
  };

  if (meta && meta.error && meta.touched) {
    configInput.className = 'invalid';
  }

  return (
    <div>
      <StyledInput {...configInput} ref={ref} />
      {meta && meta.error && meta.touched && (
        <p style={{ marginTop: '15px', color: 'red' }}>{meta.error}</p>
      )}
      {/* {meta && meta.error && field.value !== '' && <p>{meta.error}</p>} */}
    </div>
  );
});

BaseInput.displayName = 'BaseInput';

export const StyledInput = styled.input`
  border: none;
  background-color: transparent;
  border-bottom: 1px solid #cac8b0;
  font-size: 20px;
  line-height: 24px;
  padding: 0px 0px 8px;
  border-radius: 0;
  width: 100%;
  ::placeholder {
    color: #cac8b0;
  }
  &:focus {
    outline: none;
    box-shadow: rgb(100 78 2) 0px 2px;
  }
  /* &.invalid {
    ::placeholder {
      color: red;
    }
  } */
`;

BaseInput.propTypes = {
  name: PropTypes.string,
};

export default React.memo(BaseInput);
